import { compact, map } from 'lodash';
import { FilterItemOperatorType, FilterItemType } from './FilterItem.enum';
import type { IFilterItem } from './FilterItem.interface';

export default class FilterItem implements IFilterItem {
  path: string;
  type: FilterItemType;
  operator: FilterItemOperatorType;
  operatorNot: boolean;
  values: Array<string>;

  static build = (data: IFilterItem) => new FilterItem(data);
  static blank = () => new FilterItem();

  /**
   * Constructor
   * @param {IFilterItem} data
   */
  constructor(data?: IFilterItem) {
    this.path = data?.path || '';
    this.type = FilterItemType.of(data?.type?.name);
    this.operator = FilterItemOperatorType.of(data?.operator?.name);
    this.operatorNot = data?.operatorNot === true;
    this.values = compact(map(data?.values, (obj) => String(obj)));
  }
}
